import {
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Divider,
  Link,
  Grid,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { BoxRow } from "../DataEntry/StyledFields";
import { Padding } from "@mui/icons-material";

const Requirement = ({ onAccept }) => {
  const [proceed, setProceed] = useState(false);
  const [requireError, setRequireError] = useState("");

  return (
    <>
   <Box sx={{ width: "600px", margin: "0 auto" }}>
      <BoxRow>
        <Typography variant="h6">
          <strong>E-Voucher Application for Individuals</strong>
        </Typography>
        <Typography variant="p">
          This application is ONLY for individuals who do NOT have a social
          worker, case-worker or other health advocate. All others must apply
          through their existing referring case-worker or social worker.
        </Typography>
      </BoxRow>
      <Box sx={{ my: 2, width: "100%" }}>
        <Typography variant="h6">
          <strong>
            Please read these requirements before you continue with the
            application:
          </strong>
        </Typography>

        <List component="ol" sx={{ listStyleType: "decimal", pl: 4 }}>
          <ListItem component="li" disablePadding>
            <ListItemText
              primary={
                <Typography>
                  YOU WILL BE REQUIRED TO PAY a <strong>NON-REFUNDABLE</strong>{" "}
                  $15 APPLICATION FEE before approval of your application.
                </Typography>
              }
            />
          </ListItem>

          <ListItem component="li" disablePadding>
            <ListItemText
              primary={
                <Typography>
                  YOU MUST HAVE A CURRENT EYEGLASS PRESCRIPTION DATED WITHIN THE
                  LAST 24 MONTHS. If you have an older prescription, New Eyes
                  provides online vision testing and renewal of prescriptions
                  for eligible applicants. Eligibility depends on which state
                  you live in and your age.
                </Typography>
              }
            />
          </ListItem>

          <ListItem component="li" disablePadding>
            <ListItemText
              primary={
                <Typography>
                  YOU MUST HAVE YOUR PUPILLARY DISTANCE MEASUREMENT. If it is
                  not included on the eyeglasses prescription (preferable) you
                  may measure it yourself. Instructions can be found{" "}
                  <Link
                    href="https://new-eyes.org/pdmeasurement"
                    target="_blank"
                    rel="noopener"
                  >
                    here
                  </Link>
                  .
                </Typography>
              }
            />
          </ListItem>

          <ListItem component="li" disablePadding>
            <ListItemText
              primary={
                <Typography>
                  YOU WILL BE REQUIRED TO UPLOAD VERIFICATION OF NEED (e.g. a
                  photo or screenshot of your Snap Benefits, Unemployment
                  Assistance, most recent tax return, or other confirmation of
                  financial need).
                </Typography>
              }
            />
          </ListItem>

          <ListItem component="li" disablePadding>
            <ListItemText
              primary={
                <Typography>
                  YOU WILL RECEIVE AN EMAIL IN RESPONSE TO YOUR ONLINE
                  APPLICATION WITHIN 2 BUSINESS DAYS. If you are approved for
                  our program, instructions on how to order your glasses online
                  will be included in the email.
                </Typography>
              }
            />
          </ListItem>
        </List>
      </Box>

      <Grid item xs={12}>
        <Grid
          container
          direction="row"
          style={{ marginTop: "20px", marginBottom: "54px" }}
        >
          <Grid item xs={1}>
            <Checkbox
              required
              id="chkboxLabel"
              color="primary"
              checked={proceed}
              onChange={(e, checked) => {
                if (checked) setRequireError("");
                setProceed(checked);
              }}
            />
          </Grid>
          <Grid item xs={11}>
            <label htmlFor="chkboxLabel">
              I agree to pay the <strong>NON-REFUNDABLE</strong> $15 application
              fee and have read the requirements to participate in the program.
              I wish to continue with the application process.
            </label>
            <Typography
              variant="error"
              color="error"
              style={{ marginTop: "12px" }}
            >
              &nbsp;&nbsp;{requireError}
            </Typography>
          </Grid>
          <Grid item xs={12}>
          <Typography variant="body1" sx={{ marginTop: "24px" }}>
              If you have questions about eligibility or the application
              process, please reach out to New Eyes at
              <br />
              <a href="mailto:info@new-eyes.org">info@new-eyes.org</a>
            </Typography>
          </Grid>
        </Grid>
        <Button
          fullWidth
          type="submit"
          variant="contained"
          sx={{ marginBottom: "32px"}}
          onClick={(e) =>
            proceed
              ? onAccept(true)
              : setRequireError("Please check this box if you want to proceed.")
          }
        >
          Continue
        </Button>
      </Grid>
      </Box>
    </>
  );
};

export default Requirement;
